var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkCheckbox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 5.5,
    fill: "#F4F0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 6.5L8.25065 12.9167L5.33398 10",
    stroke: "#6F00FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 5.5,
    stroke: "#6F00FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkCheckbox);
export default __webpack_public_path__ + "static/media/mark_checkbox.e37739b9908cd46a05b0010c84fe1341.svg";
export { ForwardRef as ReactComponent };